import React from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

const RealizationLightbox = ({ realization, currentIndex, onClose, onNext, onPrev, onSelectIndex }) => {
  if (!realization) return null;

  const images = realization.images || [];
  const total = images.length;

  return (
    <div
      className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="lightbox-overlay"
    >
      <button onClick={onClose} className="absolute top-4 right-4 text-white hover:text-gray-300 z-50" data-testid="lightbox-close">
        <X className="w-8 h-8" />
      </button>
      <div className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
        <div className="relative">
          <img
            src={images[currentIndex]}
            alt={realization.title}
            className="w-full max-h-[70vh] object-contain rounded-lg"
            data-testid="lightbox-image"
          />
          {total > 1 && (
            <>
              <button
                onClick={onPrev}
                className="absolute left-2 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/40 rounded-full flex items-center justify-center text-white transition-colors"
                data-testid="lightbox-prev"
              >
                <ChevronLeft className="w-6 h-6" />
              </button>
              <button
                onClick={onNext}
                className="absolute right-2 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/40 rounded-full flex items-center justify-center text-white transition-colors"
                data-testid="lightbox-next"
              >
                <ChevronRight className="w-6 h-6" />
              </button>
            </>
          )}
        </div>
        {total > 1 && (
          <div className="flex justify-center gap-2 mt-4">
            {images.map((img, idx) => (
              <button
                key={img}
                onClick={() => onSelectIndex(idx)}
                className={`w-16 h-12 rounded overflow-hidden border-2 transition-colors ${idx === currentIndex ? 'border-orange-500' : 'border-transparent opacity-60 hover:opacity-100'}`}
              >
                <img src={img} alt="" className="w-full h-full object-cover" />
              </button>
            ))}
          </div>
        )}
        <div className="mt-6 text-white text-center">
          <h3 className="text-2xl font-semibold">{realization.title}</h3>
          <p className="text-gray-300 mt-2">{realization.category}</p>
          <p className="text-gray-400 mt-1 text-sm">Photo {currentIndex + 1} sur {total}</p>
        </div>
      </div>
    </div>
  );
};

export default RealizationLightbox;
